module.exports = __webpack_public_path__ + "img/icon-level-4.ef75b7c6.png";